<template>
  <div>

    <!-- HERO -->
    <div
      class="hero-section"
      :style="{
        backgroundImage:
          informations && informations.header_img
            ? 'url(https://admin.asso-refuge.fr/images/' + informations.header_img + ')'
            : 'none'
      }"
    >
      <div class="hero-text">Dog Paradise Ardèche</div>
    </div>

 <div class="container-75 value-boxes">
  <div class="row d-none d-md-flex justify-content-center ">
    <!-- Grille classique pour desktop -->
    <div class="col-md-3 " v-for="(item, i) in items" :key="i" @click="navigate(item)" style="cursor: pointer;">
      <div class="value-box hovereffect">
        <div class="value-icon"><i :class="item.icon"></i></div>
        <p><b>{{ item.title }}</b></p>
        <p>{{ item.text }}</p>
      </div>
    </div>
  </div>

  <!-- Slider horizontal pour mobile -->
<div class="d-flex d-md-none overflow-auto flex-nowrap px-2 gap-3">
  <div
    class="slider-box flex-shrink-0"
    v-for="(item, i) in items"
    :key="i"
    @click="navigate(item)"
    style="cursor: pointer;"
  >
    <div class="value-box text-center">
      <div class="value-icon"><i :class="item.icon"></i></div>
      <p><b>{{ item.title }}</b></p>
      <p>{{ item.text }}</p>
    </div>
  </div>
</div>
</div>
<br>
    <!-- DERNIERS ARRIVÉS -->
    <div class="container-75 margin20">
      <div class="text-center mb-4">
        <div class="pate">
          <i class="fas fa-paw coologreen"></i>
        </div>
        <h2 class="font-weight-bold mb-4 text-center">Les derniers arrivés</h2>
      </div>
    </div>

<homeData :chiens="chiens" :chats="chats" />


      <router-link style="color:white !important" to="/animaux">
        <div class="red_button shop_now_button buttonadaptatif bluenow">
            Voir tous nos animaux
        </div>
      </router-link>

    <div id="actuID" class="seperation"></div>

    <!-- ACTUS -->
    <div class="homeContainerRefuge my-5">
      <h2 class="font-weight-bold mb-4 text-center">Les Dernières Actualités</h2>

      <div class="row g-4 justify-content-center">
        <div
          class="col-12 col-sm-6 col-lg-3"
          v-for="actu in news.slice(0, 4)"
          :key="actu.id"
        >
          <router-link :to="'/publication/' + actu.id" class="news-card">
            <div
              class="news-card-bg"
              :style="{
                backgroundImage:
                  'url(https://admin.asso-refuge.fr/images/' + actu.image + ')'
              }"
            ></div>

            <div class="news-card-gradient"></div>
            <div class="news-card-title">{{ actu.nom }} </div>
          </router-link>
        </div>
      </div>
    </div>
      <router-link style="color:white !important" to="/actualites">
        <div class="red_button shop_now_button buttonadaptatif bluenow">
            Voir toutes nos actualités
        </div>
      </router-link>

    <div class="seperation"></div>

    <!-- INFORMATIONS -->
    <div class="homeContainerRefuge" id="refuge">
      <div class="container">
        <h2 class="font-weight-bold mb-4 text-center">Les Informations</h2>
      </div>

      <div class="container">
        <div class="row">

          <!-- MAP -->
          <div class="col-lg-7 col-12">
            <div class="card" style="border-radius: 10px;">
              <div class="container" style="margin-top: 20px;">
                <div class="map-container" v-if="showMap">
                    <img
                      src=""
                      alt="Carte du refuge Dog Paradise Ardèche à Baix,  dans l ardeche, prohe de valence"
                      class="img-fluid"/>
                </div>
              </div>
            </div>
          </div>

          <!-- INFOS -->
          <div class="col-lg-5">
            <div class="card" style="border-radius: 10px;">
              <div class="container" style="margin-top: 20px;">
                <h4 class="titleblue"><b>Email :</b></h4>
                <p v-html="formattedEmail"></p>
              </div>
            </div>

            <div class="card" style="border-radius: 10px;">
              <div class="container" style="margin-top: 20px;">
                <h4 class="titleblue"><b>Adresse :</b></h4>
                <p v-html="formattedAdresse"></p>
              </div>
            </div>

            <div class="card" style="border-radius: 10px;">
              <div class="container" style="margin-top: 20px;">
                <h4 class="titleblue"><b>Téléphone :</b></h4>
                <p v-html="formattedPhone"></p>
              </div>
            </div>

            <div class="card" style="border-radius: 10px;">
              <div class="container" style="margin-top: 20px;">
                <h4 class="titleblue"><b>Horaires :</b></h4>
                <p v-html="formattedHorraire"></p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
import homeData from '../components/homeData.vue'
</script>

<script>
export default {
  data() {
    return {
      informations: null,
      news: [],
      animaux: [],
      chats: [],
      chiens: [],
 items: [
      {
        icon: 'fas fa-paw coologreen',
        title: 'Information',
        text: 'Retrouvez les informations du refuge',
        route: { path: '/', hash: '#refuge' },
      },
      {
        icon: 'fas fa-hands-helping coolored',
        title: 'Nos Animaux',
        text: 'Retrouvez les animaux du refuge',
        route: { path: '/animaux' },
      },
      {
        icon: 'fas fa-chalkboard-teacher coologreen',
        title: 'Actualités',
        text: 'Retrouvez les actualités du refuge',
        route: { path: '/actualites' },
      },
      {
        icon: 'fas fa-heart coolored',
        title: 'S.O.S',
        text: 'Ces animaux ont besoin de vous',
        route: { path: '/sos' },
      },
    ],
      showMap: false
    }
  },

  mounted() {
    const idSite = this.$idSite

    fetch(`https://admin.asso-refuge.fr/getInformations/${idSite}`)
      .then(res => res.json())
      .then(data => {
        if (data && data.length) {
          this.informations = data[0]
        }
      })

    fetch(`https://admin.asso-refuge.fr/getNews/${idSite}`)
      .then(res => res.json())
      .then(data => (this.news = data || []))

    fetch(`https://admin.asso-refuge.fr/getAnimal/${idSite}`)
      .then(res => res.json())
      .then(data => {
        this.animaux = data || []
        this.chats = this.animaux.filter(a => a.type === 'chat')
        this.chiens = this.animaux.filter(a => a.type === 'chien')
      })

    // RENDER MAP APRÈS LAYOUT
    this.$nextTick(() => {
      setTimeout(() => {
        this.showMap = true
      }, 150)
    })
  },
    methods: {
    navigate(item) {
    this.$router.push(item.route);
  },
  },

  computed: {
    formattedHorraire() {
      return this.informations?.horraire?.replace(/\r\n/g, '<br>') || ''
    },
    formattedEmail() {
      return this.informations?.email?.replace(/\r\n/g, '<br>') || ''
    },
    formattedAdresse() {
      return this.informations?.address?.replace(/\r\n/g, '<br>') || ''
    },
    formattedPhone() {
      return this.informations?.phone?.replace(/\r\n/g, '<br>') || ''
    }
  }
}

</script>

<style scoped>
.map-container {
  width: 100%;
  min-height: 500px;
}
</style>
